import React from "react"

import CloseIcon from "../../images/closeIcon.svg"

export default function SelectedFilterCategory(props) {
  const {
    jobLocation,
    job_type,
    seniority_level,
    handleJobTypeChange,
    handleSeniorityLevelChange,
    handleLocationChange,
    handleSalaryChange,
    handleExperienceChange,
  } = props

  const handleClearAll = () => {
    handleJobTypeChange([])
    handleSeniorityLevelChange([])
    handleLocationChange({})
    handleSalaryChange({ min: "", max: "" })
    handleExperienceChange({ min: undefined, max: undefined })
  }
  return (
    <div className="wdn-selected-category pb-16px">
      <div className="row">
        <div className="col-lg-9">
          <div className="d-flex justify-content-start align-items-center gap-8px flex-wrap">
            {job_type.length > 0 &&
              job_type.map((item, index) => (
                <div className="wsc-item " key={item.name + index.toString()}>
                  <span>{item.name}</span>
                  <button
                    type="button"
                    onClick={() => {
                      handleJobTypeChange(
                        job_type.filter(job => job.id !== item.id)
                      )
                    }}
                  >
                    <img src={CloseIcon} alt="" className="img-fluid" />
                  </button>
                </div>
              ))}
            {seniority_level.length > 0 &&
              seniority_level.map((item, index) => (
                <div className="wsc-item " key={item.name + index.toString()}>
                  <span>{item.name}</span>
                  <button
                    type="button"
                    onClick={() => {
                      handleSeniorityLevelChange(
                        seniority_level.filter(s_item => s_item.id !== item.id)
                      )
                    }}
                  >
                    <img src={CloseIcon} alt="" className="img-fluid" />
                  </button>
                </div>
              ))}

            {jobLocation.id ? (
              <div className="wsc-item ">
                <span>{jobLocation?.district}</span>
                <button
                  type="button"
                  onClick={() => {
                    handleLocationChange("")
                  }}
                >
                  <img src={CloseIcon} alt="" className="img-fluid" />
                </button>
              </div>
            ) : (
              ""
            )}

            <button
              className="btn btn-filled-v4"
              onClick={e => {
                e.preventDefault()
                handleClearAll()
              }}
            >
              Clear All
            </button>
          </div>
        </div>
        <div className="col-lg-3">
          <h6 className="text-end">Showing all {props.totalItem} results</h6>
        </div>
      </div>
    </div>
  )
}
